const featuresTech = {  
  "features" : { 
    "Thermometer" : {
      "title" : "Stainless Steel Thermometer",
      "text" : "Hermetically sealed thermometer gauges temperature inside the grill to assist in determine cook time.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1567005836/10-1270_coverImage.jpg"
    },
    "Tri-Clad" : {
      "title" : "Tri-Clad",
      "text" : "Encapsulated Tri-Clad bottoms (Stainless Steel, Aluminum, and Magnetic Stainless Steel) for perfect heat distribution.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1552063875/tri-clad_coverImage.png"
    },
    "Removable Handle" : {
      "title" : "Easily Removable Handle",
      "text" : "Thumb release trigger handles easily attach and detach with just one hand.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1606244337/2021%20Domestic%20Marine%20DVD/10-361_Cookware_Handle_3rd_Generation_pk5tdv.jpg"
    },
    "Space saver" : {
      "title" : "Ultimate Space Saver",
      "text" : "Nests and stores in less than 1/2 ft³ (0.01 m³) of cabinet space.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1606244329/2021%20Domestic%20Marine%20DVD/A10-366-2-IND_Stored_bntvh4.jpg"
    },
    "ruler" : {
      "title" : "Engraved Ruler",
      "text" : "Included to measure the day's catch.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1609195153/Table_ruler_detail_gm1jfv.jpg"
    },
    "Tool holder" : {
      "title" : "Tool Holders",
      "text" : "For easy access to your fillet knives and pliers.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1609195322/Table_Knife_and_Pliers_details_ygzc0t.jpg"
    },
    "drainage" : {
      "title" : "Overboard Drainage",
      "text" : "Slotted table back that permits draingage to keep your work station clean of scales and residue.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1609195821/Table_drainage_detail_we4vvs.jpg"
    },
    "Dock mounted" : {
      "title" : "Dock Mount",
      "text" : "Mounts directly to your dock.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1609196522/Dock_mounted_detail_wbxtvd.jpg"
    },
    "vert" : {
      "title" : "Vertical Rotation",
      "text" : "Easily rotates vertically for storage.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1540593545/t10-449b-hdp_rotate_square.png"
    },
    "side station" : {
      "title" : "Optional Side Station",
      "text" : "Includes drink and hose holder, with additional knife and plier slots.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1552063629/t10-485_coverImage.jpg"
    },
    "SS rect handle" : {
      "title" : "Full Length Stainless Steel Handle",
      "text" : "Provides access from either side; makes mounting and transporting easier.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1609202744/SS_tubular_handle_detail_avvphn.jpg"
    },
    "SS kettle handle" : {
      "title" : "Cast Stainless Steel Handle",
      "text" : "”Stay Cool” Cast 18-8 Stainless Steel Handle with Air Cooled Supports.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1609262547/cast_stainless_kettle_handle_detail_tfdg2k.jpg"
    },
    "Rect Plastic Handle" : {
      "title" : "Stay Cool Handle",
      "text" : "Durable, heat resistant all weather plastic handle with air cooled supports.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1609262784/stay_cool_handle_details_jrj3uu.jpg"
    },
    "kettle Plastic Handle" : {
      "title" : "Stay Cool Handle",
      "text" : "Durable, heat resistant all weather plastic handle with air cooled supports.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1609282018/kettle_plastic_handle_details_zmf1ff.jpg"
    },
    "draft door" : {
      "title" : "Draft Door Assembly",
      "text" : "Variable Draft Door Assembly Provides Convenient Temperature Control.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1609263506/draft_door_assembly_detail_tjm9ra.jpg"
    },
    "lock lid" : {
      "title" : "Lockable Balanced Lid",
      "text" : "Lockable, balanced lid, will not slam shut and secures all inner components for transport.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1552072732/12-943_coverImage_square.jpg"
    },
    "balance lid" : {
      "title" : "Balanced Hinged Lid",
      "text" : "The perfectly balanced hinged lid will not slam shut and will act as a windshield in gusty wind conditions.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1542049567/a10-205_mounted_open_square.jpg"
    },
    "index bowl" : {
      "title" : "Indexed Bowl",
      "text" : "Before lighting, grill may be rotated for lid to act as a windshield in gusty wind conditions.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1552072636/12-558_coverImage_square.jpg"
    },
    "Lbracket" : {
      "title" : "Cast Stainless Steel L-Bracket Mount Clamp",
      "text" : "Indexed for positive non-slip level mounting.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1556208580/10-664_coverImage.jpg"
    },
    "combo grease" : {
      "title" : "Combination Grease Catch Pan/Wind Baffle",
      "text" : "Keeps the wind gusts out while keeping the flames and grease in.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1556208532/10-161_coverImage.jpg"
    },
    "QR rad plate" : {
      "title" : "Quick-Release Radiant Plate",
      "text" : "Stainless steel radiant plate provides perfect heat distribution, is easy to remove and clean up.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1556208620/10-964_coverImage.jpg"
    },
    "kettle igniter" : {
      "title" : "Electronic Ignition",
      "text" : "Dependable, electronic igntion allows easy grill lighting.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1556208614/10-960-r_coverImage.jpg"
    },
    "rectangle igniter" : {
      "title" : "Electronic Ignition",
      "text" : "Dependable, electronic igntion allows easy grill lighting.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1556208614/10-960-r_coverImage.jpg"
    },
    "fold legs" : {
      "title" : "Fold Away Legs",
      "text" : "Perfect for grilling everywhere.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1609268909/folding_legs_detail_ittjmo.jpg"
    },
    "lock grease tray front" : {
      "title" : "Locking Front Access Grease Tray",
      "text" : "Accessible from the front for easy access and grease removal.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1609269441/front_locking_grease_tray_details_ldnlvi.jpg"
    },
    "Inner Lined Shell" : {
      "title" : "Inner Lined Safety Shell",
      "text" : "Reduces flare-ups and heat discoloration by funneling grease into the front access grease tray.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1552072743/12-958_coverImage_square.jpg"
    },
    "lock grease tray side" : {
      "title" : "Locking Side Grease Tray",
      "text" : "Accessible From Either Side for easy grease removal.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1552072416/10-968_coverImage_square.jpg"
    },
    "Window" : {
      "title" : "Viewing Window",
      "text" : "Ultra high temp, glass viewing window allows a visual on the food without opening the grill.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1609269780/viewing_windo_details_v7biv1.jpg"
    },
    "venturi tube" : {
      "title" : "Windproof Swiveling Tubo Venturi Tube",
      "text" : "Virtually eliminates blowouts and places fuel and valve where it is convenient for you.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1552072332/10-160_coverImage_square.jpg"
    },
    "Warming Rack" : {
      "title" : "Warming Rack/Secondary Grilling Area",
      "text" : "The upper secondary grilling area, with tightly spaced grill struts, is ideal for slow grilling or warming food of any size.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1606244260/2021%20Domestic%20Marine%20DVD/A10-1218-2GS_Open_w_Food_and_Serving_Shelf_rdip3m.jpg"
    },
    "grill grates" : {
      "title" : "Sectional Grill Grates",
      "text" : "Durable stainless steel grates are easy to clean as they fit nicely in sinks or dishwashers.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1552072317/10-1254_coverImage_square.jpg"
    },
    "fold racks" : {
      "title" : "Folding Racks",
      "text" : "Folds Flat Along Rail When Not in Use or Easily Remove From Rail Without Tools for Compact Storage.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1563211996/r10-626-20_overview.jpg"
    },
    "mnt brackets" : {
      "title" : "Stainless Steel Mounting Brackets",
      "text" : "Each Arm has (2) Heavy Duty Stainless Steel Mounting Brackets and Stainless Steel Hardware.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1609366260/rack_mounting_bracket_details_ix6yxc.jpg"
    },
    "tie down" : {
      "title" : "Tie-Down Points",
      "text" : "(2) Stainless Steel Tie-Down Points on Each Arm to secure the kayak or SUP to the rack.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1606244323/2021%20Domestic%20Marine%20DVD/R10-626_R10-626-20_Foam_Pad_Cut_Away_w_Tie-Down_Loop_y5tiqm.jpg"
    },
    "cover" : {
      "title" : "Protective Covers",
      "text" : "Includes Pre-Installed UV Resistant Foam Padding with Heavy Duty UV Resistant 600D Polyester Protective Covers to prevent any damage to the kayak or SUP.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1572461842/12-626c-20_coverImage.jpg"
    },
    "levellock" : {
      "title" : "Easy Adjustment",
      "text" : "Magma’s LeveLock® adjusts to fit any direction or angle of rod holder without tools so you can quickly and easily adjust the angle of the rack.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1606244239/2021%20Domestic%20Marine%20DVD/T10-192_Pedestal_Mount_upzczv.jpg"
    },
    "rack dock mnt" : {
      "title" : "Dock Surface Mount",
      "text" : "Freestanding, mounts on any dock or flat furface for added versatility.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1609368932/dock_mount_rack_details_svkhqh.jpg"
    },
    "custom" : {
      "title" : "Customizible",
      "text" : "Straight Arms and SUP Arms (sold in pairs) are Purchased Separately to Customize the Rack to Your Requirements. Arms Adjust Every 2 in. (58.8 mm) To Maximize Storage Capacity.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1577127424/r10-1001_witharms_03.jpg"
    },
    "water mount" : {
      "title" : "Over Water Mount",
      "text" : "Mounts to Any Dock Out Over the Water, saving space on the dock.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1609369236/over_water_mount_rack_details_ecunqq.jpg"
    },
    "wall mount" : {
      "title" : "Wall Mount System",
      "text" : "Convenient Wall Mounted Folding Storage Rack; Mounts To Any Wall or Flat Vertical Surface.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1606244309/2021%20Domestic%20Marine%20DVD/R10-1004-59_Adjustment_Position_Illustrations_01_gu1ykx.jpg"
    },
    "flat" : {
      "title" : "Compact",
      "text" : "Unique Design Allows the Rack to Fold Perfectly Flat Against the Wall When Not in Use",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1562090822/r10-1004-59_closedPosition.jpg"
    },
    "umb mount" : {
      "title" : "Rail Mount Options",
      "text" : "Quick Release All-Angle Round Rail Mount Available in (3) Different Sizes, Easily Adjusts to Any Position.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1606244182/2021%20Domestic%20Marine%20DVD/Umbrella_Rail_Mount-Vertical_bc11z3.jpg"
    },
    "umb tie down" : {
      "title" : "Tie-Down Points",
      "text" : "Umbrella Can Be Used With or Without included Tie-Down Lines to secure the umbrella in windy conditions.",
      "image" : "https://res.cloudinary.com/magma-products/image/upload/v1609371306/umbrella_tie_down_details_qlce4l.jpg"
    }
  },
  "tech" : {
    "UV block" : {
      "title" : "100% UV Block",
      "text" : "18-10 stainless steel with a ferromagnetic stainless steel base for use on induction cooking systems.",
      "category" : "umbrella",
      "icon" : "https://cdn.shopify.com/s/files/1/0507/2181/6769/files/icon-uv-block.svg?v=1611561005"
    },
    "18-10 SS" : {
      "title" : "18-10 Stainless Steel",
      "text" : "18-10 stainless steel with a ferromagnetic stainless steel base for use on induction cooking systems.",
      "category" : "cookware",
      "icon" : "https://cdn.shopify.com/s/files/1/0507/2181/6769/files/icon-stainless-steel.svg?v=1611561119"
    },
    "dual IR plate" : {
      "title" : "Dual Element Infrared Radiant Plate",
      "text" : "Stainless steel radiant plate helps maximize fuel efficiency, provides perfect heat distribution, is easy to remove and clean up.",
      "category" : "grill",
      "icon" : "https://cdn.shopify.com/s/files/1/0507/2181/6769/files/icon-infrared-plate.svg?v=1611561152"
    },
    "no tool adjust" : {
      "title" : "Easily Adjustable",
      "text" : "Instantly Adjusts Without Tools to Fit Kayaks, SUPs, and Other Water Toys (Holds up to 3 Standard SUPs).",
      "category" : "rack",
      "icon" : ""
    },
    "FDA" : {
      "title" : "FDA Approved",
      "text" : "Material is approved by the FDA and safe to use for food preparation.",
      "category" : "table",
      "icon" : "https://cdn.shopify.com/s/files/1/0507/2181/6769/files/icon-fda-approved.svg?v=1611561245"
    },
    "HDP" : {
      "title" : "HDP",
      "text" : "Provides intense even heat for searing, reduces flare-ups, and eliminates blow outs.",
      "category" : "table",
      "icon" : ""
    },
    "IR Screen" : {
      "title" : "Infrared Radiant Screens",
      "text" : "",
      "category" : "grill",
      "icon" : "https://cdn.shopify.com/s/files/1/0507/2181/6769/files/icon-infrared-screens.svg?v=1611561458"
    },
    "Injection molded" : {
      "title" : "Injection Molded",
      "text" : "UV stabilized, injection molded polyethylene is strong, yet lightweight material.",
      "category" : "table",
      "icon" : "https://cdn.shopify.com/s/files/1/0507/2181/6769/files/icon-injection-mold.svg?v=1611561483"
    },
    "Grill mnt" : {
      "title" : "Largest Selection of Mounts",
      "text" : "Magma offers the largest selection of mounting options to customize your grill to your boat.",
      "category" : "grill",
      "icon" : ""
    },
    "USA" : {
      "title" : "Made in the USA",
      "text" : "Product is proudly manufactured in the United States.",
      "category" : "table, grill, parts",
      "icon" : "https://cdn.shopify.com/s/files/1/0507/2181/6769/files/icon-made-in-the-usa.svg?v=1611561532"
    },
    "Kettle" : {
      "title" : "Magma's Patented Kettle Design",
      "text" : "Magma’s patented design fully utilizes both radiant and convection cooking. Quickly comes to temperature then heats the entire grill surface evenly while using the least amount of fuel.",
      "category" : "grill",
      "icon" : "https://cdn.shopify.com/s/files/1/0507/2181/6769/files/icon-kettle.svg?v=1611561553"
    }, 
    "MG-Steel" : {
      "title" : "Mirror Polished Marine Grade Stainless Steel",
      "text" : "Constructed entirely of 100% 18-9 mirror polished, marine grade stainless steel to withstand the harshest marine environment.",
      "category" : "grill",
      "icon" : ""
    },
    "OD steel" : {
      "title" : "Mirror Polished Stainless Steel",
      "text" : "Constructed entirely of100% mirror polished stainless steel to withstand the harshest outdoor environments.",
      "category" : "grill",
      "icon" : ""
    },
    "Non-stick" : {
      "title" : "Non-stick",
      "text" : "Durable, non-stick surface coating for ease of cooking and cleaning. PFOA and PTFE free.",
      "category" : "cookware",
      "icon" : "https://cdn.shopify.com/s/files/1/0507/2181/6769/files/icon-non-stick.svg?v=1611561617"
    },
    "Oven Safe" : {
      "title" : "Oven Safe",
      "text" : "Cookware and lids are oven safe to 500° F (260° C) (excluding removable handles)",
      "category" : "cookware",
      "icon" : "https://cdn.shopify.com/s/files/1/0507/2181/6769/files/icon-oven-safe.svg?v=1611561638"
    },
    "powr grip" : {
      "title" : "Pow'r Grip",
      "text" : "Instantly locks into any angle standard fish rod holder with Magma’s Pow’rGrip Technology.",
      "category" : "rack",
      "icon" : ""
    },
    "dome heat distro" : {
      "title" : "Radiant Burner Plate and Dome Heat Distribution System",
      "text" : "Burner plate and dome design provides perfect, evenly distributed heat as a grill or direct open flame cooking as a stove. It reduces flare ups and helps extend the life of the grill.",
      "category" : "grill",
      "icon" : ""
    },
    "rad plate" : {
      "title" : "Radiant Plate Heat Distribution Design",
      "text" : "Reduces flare ups and helps extend the life of the grill.",
      "category" : "grill",
      "icon" : ""
    },
    "sealed body" : {
      "title" : "Sealed Body",
      "text" : "Sealed body keeps grease and ash contained.",
      "category" : "grill",
      "icon" : ""
    },
    "swivel control valve" : {
      "title" : "Swiveling Control Valve",
      "text" : "Allows for quick and safe fuel canister exchange.",
      "category" : "grill",
      "icon" : ""
    }
  }
}